<template>
	<div class="header black lighten-1 py-3">
		<v-container class="py-0">
			<v-layout row wrap>
				<v-flex xs2>
					<v-toolbar-side-icon v-if="!hideDrower" class="drawer-trigger white--text mx-3 my-2" @click="drawer = !drawer"></v-toolbar-side-icon>
				</v-flex>
				<v-flex xs10>
					<div class="right">
						<div v-if="userType == 1" class="system-admin-button-wrapper">
							<v-btn flat href="/system-administrators">
								<v-icon class="white--text system-admin-button">settings</v-icon>
								<span class="subheading font-weight-bold white--text text-capitalize ml-2">System Admin</span>
							</v-btn>
						</div>
						<v-btn flat @click="logout">
							<v-icon class="white--text logout-button">exit_to_app</v-icon>
							<span class="subheading font-weight-bold white--text text-capitalize ml-2">Log out</span>
						</v-btn>
						<span white icon class="text-uppercase center primary--text user-prev title ml-3">{{userFirstName.charAt(0)}} {{userSurname.charAt(0)}}</span>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
		<v-navigation-drawer mobile-break-point="1904" v-if="!hideDrower" app width="396" class="white pt-3 cc__box-shadow cc__drawer" v-model="drawer">
			<div class="drawer-heading pl-4 pr-2 mb-5">
				<a href="/" title="Home" class="logo">
					<img src="../assets/images/cc_black.png" alt="CoCreate" />
				</a>	
				<v-btn height="50" @click="drawer = !drawer" icon>
					<v-icon class="title" >close</v-icon>
				</v-btn>
			</div>
			<v-list class="pa-0">
				<v-list-tile :style="`${(userType != 1 &&  link.className == 'companies') || (userType == 1 && !companyId) ? 'display:none;' : ''}`" :class="`grey lighten-3 ${active == link.text ? 'active' : ''}`" :id="`${link.className}`" height="66" v-for="link in links" :key="link.text" router :to="link.route">
					<v-list-tile-action class="pl-4 pr-4">
						<v-icon class="black--text title">{{ link.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="grey--text title font-weight-regular">{{ link.text }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile v-if="userType == 1 && !companyId" class="grey lighten-3 companies" height="66" router :to="'/'">
					<v-list-tile-action class="pl-4 pr-4">
						<v-icon class="black--text title">keyboard_backspace</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="grey--text title font-weight-regular">Back to Companies</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile v-if="userType != 1" class="grey lighten-3 companies" height="66" router :to="`/company/${companyId}`">
					<v-list-tile-action class="pl-4 pr-4">
						<v-icon class="black--text title">settings</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title class="grey--text title font-weight-regular">Edit company</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>

import AuthService from "../services/auth";


  export default {
		data() {
			return {
				el: '#app',
				userType: sessionStorage.userType,
				userFirstName: sessionStorage.userFirstName,
				userSurname: sessionStorage.userSurname,
				companyId: sessionStorage.companyId,
				drawer: false,
                links: [
                    { icon: 'assignment', text: 'Contracts', route: '/contracts/' + sessionStorage.companyId, className: 'contracts'},
					{ icon: 'color_lens', text: 'Branding', route: '/offices', className: 'offices'},
					{ icon: 'people_outline', text: 'Teams', route: '/teams', className: 'teams'},
					{ icon: 'person_outline', text: 'Users', route: '/users', className: 'users'},
					{ icon: 'remove_red_eye', text: 'Administrators', route: '/administrators', className: 'administrators'},
					{ icon: 'keyboard_backspace', text: 'Back to Companies', route: '/', className: 'companies'},
				],
				username: '1'
			}
		},
		name: 'Toolbar',
		props: {
			heading: String,
			user: String,
			hideDrower: Boolean,
			active: String
		},
		created() {
    		this.authService = new AuthService();
		},
		methods: {
			logout() {
				this.authService.logout()
			}
		}
	}

</script>>

<style lang="scss">

	.header {

		.system-admin-button-wrapper {
			display: inline-block;
		}

		@media (max-width: 599px) {
			.right {
				text-align: right;

				.system-admin-button-wrapper {
					width: 100%;
					text-align: right;

					a {
						margin-right: 0;
					}
				}

				a, button {
					padding: 0;
				}
			}
		}
	}

	.drawer-trigger {
		position: absolute;
		left: 0;
		&:hover {
			position: absolute;
		}
	}
	.v-navigation-drawer {
		img {
			width: 50px;
			border-radius: 50%;
		}
		.v-list__tile__action {
			min-width: 50px;
		}
	}
	.drawer-heading {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-pack: justify;
      	-ms-flex-pack: justify;
        justify-content: space-between;
		button {
			float: right;
		}
		.logo {
			display: inline-block;
			height: 50px;
		}
	}
	.cc__drawer {
		.v-list__tile {
			height: 66px;
			transition: background-color .2s ease !important;
			&:hover {
				background-color: rgba(112, 112, 112, .2) !important;
			}
		}
	}
</style>
